export default "__VITE_ASSET__316fb3a2__"